import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';

function AcknowledgeAlertModalContent({ alertDescription, handleTextChange }) {
  return (
    <>
      <p>
        {`Are you sure you want to acknowledge ${alertDescription}?
        If you've configured repeat actions for this alert, acknowledging the alert will prevent further repetition.`}
      </p>
      <br />
      <br />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="control-label">
        <Icon icon="comment" />
        {' '}
                &nbsp;
        <b>Add Comment</b>
        (Optional)
      </label>
      <textarea
        className="form-control customized-text"
        rows="5"
        style={{ resize: 'none' }}
        placeholder="Write a comment ..."
        onChange={(e) => handleTextChange(e.target.value)}
      />
    </>
  );
}

AcknowledgeAlertModalContent.propTypes = {
  alertDescription: PropTypes.string.isRequired,
  handleTextChange: PropTypes.func.isRequired,
};

export default AcknowledgeAlertModalContent;
